const switchTheme = document.querySelector('.switch--theme');
const currentTheme = window.localStorage.getItem('data-theme');

if (currentTheme) document.documentElement.setAttribute('data-theme', currentTheme);

if (switchTheme) {
    switchTheme.addEventListener('click', () => {
        if (document.documentElement.getAttribute('data-theme') === 'contrast') {
            document.documentElement.setAttribute('data-theme', 'default');
            window.localStorage.setItem('data-theme', 'default');
        } else {
            document.documentElement.setAttribute('data-theme', 'contrast');
            window.localStorage.setItem('data-theme', 'contrast');
        }
    });
}
